import * as types from './types';
import { studentNotFoundMessage } from '../helpers/Constants';

const INITIAL_STATE = {
  // Configuration
  configuration: {
    loading: false,
    data: null,
    errors: { getError: null, writeError: null },
    saveSuccessful: false,
  },
  // Mappings
  mapping: {
    loading: false,
    data: null,
    errors: { getError: null, writeError: null },
    saveSuccessful: false,
  },

  //Languages
  languages: {
    loading: false,
    data: null,
    errors: null,
  },

  preview: {
    loading: false,
    importLoading: false,
    data: null,
    errors: {
      previewError: null,
      importError: null,
      studentNotFoundError: false,
    },
    previewSuccessful: false,
    importSuccessful: false,
  },
  manualSync: {
    loading: false,
    errors: null,
    manualSyncComplete: false,
  },
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.AERIES_GET_CONFIGURATION_SUCCESS: {
      const { configuration } = state;
      return { ...state, configuration: { ...configuration, data: payload } };
    }

    case types.AERIES_CONFIGURATION_LOADING: {
      const { configuration } = state;
      return {
        ...state,
        configuration: { ...configuration, loading: payload },
      };
    }
    case types.AERIES_GET_CONFIGURATION_ERROR: {
      const { configuration } = state;
      return {
        ...state,
        configuration: {
          ...configuration,
          errors: { ...configuration.errors, getError: payload },
        },
      };
    }

    case types.AERIES_WRITE_CONFIGURATION_SUCCESS: {
      const { configuration } = state;
      return {
        ...state,
        configuration: { ...configuration, saveSuccessful: payload },
      };
    }

    case types.AERIES_CONFIGURATION_SET_SAVE_SUCCESSFUL: {
      const { configuration } = state;
      return {
        ...state,
        configuration: { ...configuration, saveSuccessful: payload },
      };
    }

    case types.AERIES_WRITE_CONFIGURATION_ERROR: {
      const { configuration } = state;
      return {
        ...state,
        configuration: {
          ...configuration,
          errors: { ...configuration.errors, writeError: payload },
        },
      };
    }

    case types.AERIES_CONFIGURATION_CLEAR_ERRORS: {
      const { configuration } = state;
      return {
        ...state,
        configuration: {
          ...configuration,
          errors: { getError: null, writeError: null },
        },
      };
    }

    case types.AERIES_MAPPINGS_LOADING: {
      const { mapping } = state;
      return { ...state, mapping: { ...mapping, loading: payload } };
    }

    case types.AERIES_GET_MAPPINGS_SUCCESS: {
      const { mapping } = state;
      return { ...state, mapping: { ...mapping, data: payload } };
    }

    case types.AERIES_GET_MAPPINGS_ERROR: {
      const { mapping } = state;
      return {
        ...state,
        mapping: {
          ...mapping,
          errors: { ...mapping.errors, getError: payload },
        },
      };
    }

    case types.AERIES_WRITE_MAPPINGS_SUCCESS: {
      const { mapping } = state;
      return { ...state, mapping: { ...mapping, saveSuccessful: payload } };
    }

    case types.AERIES_WRITE_MAPPINGS_ERROR: {
      const { mapping } = state;
      return {
        ...state,
        mapping: {
          ...mapping,
          errors: { ...mapping.errors, writeError: payload },
        },
      };
    }

    case types.AERIES_GET_LANGUAGES_LOADING: {
      const { languages } = state;
      return { ...state, languages: { ...languages, loading: payload } };
    }

    case types.AERIES_GET_LANGUAGES_SUCCESS: {
      const { languages } = state;
      return { ...state, languages: { ...languages, data: payload } };
    }

    case types.AERIES_GET_LANGUAGES_ERROR: {
      const { languages } = state;
      return { ...state, languages: { ...languages, errors: payload } };
    }

    case types.AERIES_MAPPINGS_SET_SAVE_SUCCESSFUL: {
      const { mapping } = state;
      return {
        ...state,
        mapping: { ...mapping, saveSuccessful: payload },
      };
    }

    case types.AERIES_MAPPINGS_CLEAR_ERRORS: {
      const { mapping } = state;
      return {
        ...state,
        mapping: { ...mapping, errors: { getError: null, writeError: null } },
      };
    }

    case types.AERIES_GET_PREVIEW_SUCCESS: {
      const { preview } = state;
      return {
        ...state,
        preview: { ...preview, data: payload },
      };
    }

    case types.AERIES_GET_PREVIEW_ERROR: {
      const { preview } = state;
      if (payload.Message && payload.Message === studentNotFoundMessage) {
        return {
          ...state,
          preview: {
            ...preview,
            errors: { ...preview.errors, studentNotFoundError: true },
          },
        };
      }
      return {
        ...state,
        preview: {
          ...preview,
          errors: { ...preview.errors, previewError: payload },
        },
      };
    }

    case types.AERIES_PREVIEW_LOADING: {
      const { preview } = state;
      return {
        ...state,
        preview: { ...preview, loading: payload },
      };
    }

    case types.AERIES_IMPORT_STUDENT_LOADING: {
      const { preview } = state;
      return {
        ...state,
        preview: { ...preview, importLoading: payload },
      };
    }

    case types.AERIES_IMPORT_STUDENT_SET_SAVE_SUCCESSFUL: {
      const { preview } = state;
      return {
        ...state,
        preview: { ...preview, importSuccessful: payload },
      };
    }

    case types.AERIES_IMPORT_STUDENT_ERROR: {
      const { preview } = state;
      return {
        ...state,
        preview: {
          ...preview,
          errors: { ...preview.errors, importError: payload },
        },
      };
    }

    case types.AERIES_PREVIEW_CLEAR_ERROR: {
      const { preview } = state;
      return {
        ...state,
        preview: {
          ...preview,
          errors: {
            studentNotFoundError: false,
            previewError: null,
            importError: null,
          },
        },
      };
    }

    case types.AERIES_PREVIEW_RESET: {
      const { preview } = INITIAL_STATE;
      return { ...state, preview: preview };
    }

    case types.AERIES_MANUAL_SYNC_LOADING: {
      const { manualSync } = state;
      return { ...state, manualSync: { ...manualSync, loading: payload } };
    }

    case types.AERIES_MANUAL_SYNC_MANUAL_SYNC_COMPLETE: {
      const { manualSync } = state;
      return {
        ...state,
        manualSync: { ...manualSync, manualSyncComplete: payload },
      };
    }

    case types.AERIES_MANUAL_SYNC_ERROR: {
      const { manualSync } = state;
      return {
        ...state,
        manualSync: { ...manualSync, errors: payload },
      };
    }

    case types.AERIES_MANUAL_SYNC_CLEAR_ERRORS: {
      const { manualSync } = state;
      return {
        ...state,
        manualSync: { ...manualSync, errors: null },
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/aeriesintergration/state/reducer.js